import { render, staticRenderFns } from "./HomeWishlistNL.vue?vue&type=template&id=3123c565&scoped=true"
import script from "./HomeWishlistNL.vue?vue&type=script&lang=js"
export * from "./HomeWishlistNL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123c565",
  null
  
)

export default component.exports